import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { TenantService } from '../services/tenant.service';
import { RoutingService } from '../services/routing.service';

// canMatch & canActivate requires CanMatchFn so we use closures to pass applicationId to the inner function
export function applicationGuard(applicationId: string): CanMatchFn {
    return (route) => {
        // save the requested route, so that we default to it on next login
        inject(RoutingService).persistRoute(route);

        return inject(TenantService).hasApplication(applicationId);
    } 
}